import { CoreButton } from '@components'
import ConfirmIcon from '@images/icons/popup-modal-confirm.svg?react'
import WarningIcon from '@images/icons/popup-modal-warning.svg?react'
import DangerIcon from '@images/icons/popup-modal-warning-red.svg?react'
import { tr } from 'mmfintech-commons'
import { type ReactNode, useState } from 'react'

type PopupShowProps = {
  icon?: 'confirm' | 'warning' | 'danger'
  header?: ReactNode
  content: ReactNode
  confirmCaption?: string
  onConfirm: () => void
  hideCancel?: boolean
}

export const usePopupModalDialog = () => {
  const [footer, setFooter] = useState<ReactNode>(null)
  const [header, setHeader] = useState<ReactNode>(null)
  const [content, setContent] = useState<ReactNode>(null)
  const [visible, setVisible] = useState<boolean>(false)

  const popupHide = () => setVisible(false)

  const popupShow = ({ icon = 'warning', header, content, confirmCaption, onConfirm, hideCancel }: PopupShowProps) => {
    setHeader(
      <>
        {icon === 'confirm' ? <ConfirmIcon /> : icon === 'danger' ? <DangerIcon /> : <WarningIcon />}
        <span>{header}</span>
      </>
    )
    setContent(content)
    setFooter(
      <>
        <CoreButton
          variation='primary-black'
          size='large'
          fullWidth
          text={confirmCaption || tr('FRONTEND.BUTTONS.CONFIRM', 'Confirm')}
          onClick={onConfirm}
          data-test='button-confirm'
        />
        {!hideCancel && (
          <CoreButton
            variation='tertiary'
            size='large'
            text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            onClick={popupHide}
            data-test='button-cancel'
          />
        )}
      </>
    )
    setVisible(true)
  }

  return {
    show: popupShow,
    hide: popupHide,
    header,
    content,
    footer,
    visible
  }
}
